export enum AdminOrganizationAttrsApiErrorTypes {
  AdminCreateOrganizationAttrsError,
  AdminOrganizationAttrsNotFoundError,
  AdminDeleteOrganizationAttrsError,
  AdminLoadStockDigitalPeopleError,
}

export class AdminOrganizationAttrsApiError {
  constructor(public type: AdminOrganizationAttrsApiErrorTypes, public error: Error) {}
}
